module.exports = __webpack_public_path__ + "static/img/ki.db7e40f6.svg";